import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAppContext } from '@/context/AppContext';

const NAV_ITEMS = [
  { to: '/',          icon: '🏠', label: 'Home'     },
  { to: '/expenses',  icon: '📋', label: 'Expenses' },
  { to: '/planned',   icon: '📦', label: 'Planned'  },
  { to: '/budget',    icon: '💰', label: 'Budget'   },
  { to: '/analytics', icon: '📊', label: 'Analytics'},
  { to: '/todos',     icon: '✅', label: 'To-Dos', notif: true },
  { to: '/settings',  icon: '⚙️', label: 'Settings' },
];

export default function BottomNav() {
  const { todoNotifCount } = useAppContext();

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200
                 flex items-center z-40 pb-safe"
      aria-label="Main navigation"
    >
      {NAV_ITEMS.map(({ to, icon, label, notif }) => (
        <NavLink
          key={to}
          to={to}
          end={to === '/'}
          className={({ isActive }) =>
            `bottom-nav-item ${isActive ? 'active' : ''}`
          }
          aria-label={label}
        >
          <span className="relative text-xl" aria-hidden="true">
            {icon}
            {notif && todoNotifCount > 0 && (
              <span className="absolute -top-1 -right-1.5 bg-red-500 text-white text-[9px] font-bold rounded-full min-w-[14px] h-[14px] flex items-center justify-center px-0.5 leading-none">
                {todoNotifCount > 9 ? '9+' : todoNotifCount}
              </span>
            )}
          </span>
          <span>{label}</span>
        </NavLink>
      ))}
    </nav>
  );
}
